import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from "reactstrap";
import DesignCard from "../DesignCard";
import get from "lodash/get";
import history from "../../history";
import Loader from "../Loader";
import InputText from "../InputText";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomButton from "../CustomButton";
import MaterialTable from "material-table";

import { fetchQueryParams } from "../../utils/comman";
import { helperFunctionForDate } from "../../utils/helperFunction";

import "../../assets/scss/components/MeterialTable/index.scss";

const _ = { get };

export default class JoinUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: false,
      toggleRejectModal: false,
      userId: "",
      page: 0,
      phone: "",
      email: "",
      limit: 100,
      data: [],
      toggleAddUser: false,
      togglePaymentModal: false,
      paymentDetail: "CASH",
      rideId: "",
      status: "PENDING",
      rejectionReason: "",
      addUserToggle: false,
      otherPaymentReason: "",
    };
  }

  handleChangeStatus = (e) => {
    let state = this.state;
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    state.status = e.target.value;
    this.setState({ ...state });
    let data = {
      status: state.status,
      id: params.id,
    };
    this.props.handleUsersForJoinRide(data);
  };

  handleNameChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleFilterChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleGoBack = () => {
    this.props.handleToggleModel();
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    this.setState({ ...state });
  };

  handleRowData = (rowData) => {
    if (rowData.ridersClubMember !== true) {
      history.push(`/user/detail?userId=${rowData._id}`);
    } else {
      history.push(`/rides/member-detail?guid=${rowData.guid}`);
    }
  };

  handleChangePaymentStatus = (e) => {
    let state = this.state;
    state.paymentDetail = e.target.value;
    this.setState({ ...state });
  };

  handleToggleAddUser = () => {
    let state = this.state;
    state.toggleAddUser = !state.toggleAddUser;
    this.setState({ ...state });
  };

  handleApproveUserWithFee = (e, id) => {
    let state = this.state;
    state.togglePaymentModal = !state.togglePaymentModal;
    state.userId = id;
    this.setState({ ...state });
  };

  handleToggleRejectModal = (id) => {
    let state = this.state;
    state.toggleRejectModal = !state.toggleRejectModal;
    state.userId = id;
    this.setState({ ...state });
  };

  handleToggleRejectModalWithoutId = () => {
    let state = this.state;
    state.togglePaymentModal = !state.togglePaymentModal;
    this.setState({ ...state });
  };

  handleApproveUserWithoutFeeWithoutToggleModel = (e, id) => {
    let state = this.state;
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);
    let data = {
      payment: state.paymentDetail,
      userGUID: id,
      category: this.props.tab !== "add-user-ride" ? "event" : "ride",
      activityId: this.props.selectedId,
      description: state.otherPaymentReason,
    };
    this.props.handleJoinUser(data);
  };

  handleApproveUserWithoutFee = (e, id) => {
    let state = this.state;
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);

    let data = {
      payment: state.paymentDetail,
      userGUID: state.userId,
      category: this.props.tab !== "add-user-ride" ? "event" : "ride",
      activityId: this.props.selectedId,
      description: state.otherPaymentReason,
    };
    state.togglePaymentModal = !state.togglePaymentModal;
    this.setState({ ...state });
    this.props.handleJoinUser(data);
  };

  handleAddUser = () => {
    let state = this.state;
    let { elements } = this.props;
    let queryParams = this.props.query;
    const params = fetchQueryParams(queryParams);

    let data = {
      id: params.id,
      email: state.email,
      mobile: state.phone,
      moderationStatus: "",
      flag: "addUser",
    };

    if (data.email === "")
      return toast.error(
        _.get(
          elements,
          "joinAllUserElement.emailValidationElement",
          "Email cannot be empty"
        )
      );
    if (data.mobile === "")
      return toast.error(
        _.get(
          elements,
          "joinAllUserElement.phoneEmptyValidationElement",
          "Phone cannot be empty"
        )
      );
    if (data.mobile.length <= 8)
      return toast.error(
        _.get(
          elements,
          "joinAllUserElement.phoneValidationElement",
          "phone Length should be more than 7 and less than 16"
        )
      );

    return this.props.handleFetchAllUser(data);
  };
  render() {
    let { elements } = this.props;

    console.log("tab", this.props.tab);

    console.log({ allUser: this.props.allUser });
    return (
      <div className="userListing hideSearch">
        {this.props.allUserStatus !== false ? <Loader /> : null}
        <Row>
          <Col sm={12}>
            <Card className="mb-3">
              <CardBody>
                <Row>
                  <React.Fragment>
                    <Col lg={4} className="mb-4">
                      <InputText
                        labelName={_.get(
                          elements,
                          "joinAllUserElement.emailLabel",
                          "Email"
                        )}
                        inputType={"email"}
                        inputName={"email"}
                        InputClass={"my-2 inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "joinAllUserElement.emailPlaceholder",
                          "Email"
                        )}
                        customValue={this.state.email}
                        customOnChange={(e) => this.handleFilterChange(e)}
                      />
                    </Col>
                    <Col lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "joinAllUserElement.mobileLabel",
                          "Mobile Number"
                        )}
                        inputType={"number"}
                        inputName={"phone"}
                        InputClass={"my-2 inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "joinAllUserElement.mobilePlaceholder",
                          `Mobile Number (exclude prefix '0')`
                        )}
                        customValue={this.state.phone}
                        customOnChange={(e) => this.handleFilterChange(e)}
                      />
                    </Col>
                  </React.Fragment>
                </Row>
                <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                  <CustomButton
                    customType={"button"}
                    name={_.get(
                      elements,
                      "joinAllUserElement.searchButtonElement",
                      "Search"
                    )}
                    customClass={"btn-outline-dark ml-2 bg-none btnthemeColor"}
                    customClick={() => this.handleAddUser()}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <>
              {this.props.allUser.length <= 0 ? (
                <div className="custom-m-table">
                  <MaterialTable
                    title=""
                    columns={[
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.fNameElement",
                          "First Name"
                        ),
                        field: "fName",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.lNameElement",
                          "Last Name"
                        ),
                        field: "lName",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.rideStatusElement",
                          "Email"
                        ),
                        field: "contactDetails.email",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.phoneElement",
                          "Phone"
                        ),
                        field: "contactDetails.mobile.primary.number",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.moderationStatusElement",
                          "DOB"
                        ),
                        field: "dob",
                        render: (rowData) => helperFunctionForDate(rowData.dob),
                      },
                    ]}
                    data={this.props.allUser}
                    options={{
                      actionsColumnIndex: -1,
                      search: false,
                      paging: true,
                      sorting: false,
                      pageSize: 10,
                    }}
                    localization={{
                      body: {
                        emptyDataSourceMessage: (
                          <h6>
                            {_.get(
                              elements,
                              "joinAllUserElement.noRecordsFoundElement",
                              "No records to display"
                            )}
                          </h6>
                        ),
                      },
                      pagination: {
                        labelRowsSelect: _.get(
                          elements,
                          "customMaterialTableElement.labelRowsSelect",
                          "rows"
                        ),
                        previousTooltip: _.get(
                          elements,
                          "customMaterialTableElement.previousTooltip",
                          "previous"
                        ),
                        nextTooltip: _.get(
                          elements,
                          "customMaterialTableElement.nextTooltip",
                          "next"
                        ),
                      },
                    }}
                  />
                </div>
              ) : (
                <div className="custom-m-table">
                  <MaterialTable
                    title=""
                    columns={[
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.fNameElement",
                          "First Name"
                        ),
                        field: "fName",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.lNameElement",
                          "Last Name"
                        ),
                        field: "lName",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.rideStatusElement",
                          "Email"
                        ),
                        field: "contactDetails.email",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.phoneElement",
                          "Phone"
                        ),
                        field: "contactDetails.mobile.primary.number",
                      },
                      {
                        title: _.get(
                          elements,
                          "joinAllUserElement.moderationStatusElement",
                          "DOB"
                        ),
                        field: "dob",
                        render: (rowData) => helperFunctionForDate(rowData.dob),
                      },
                    ]}
                    data={this.props.allUser}
                    options={{
                      actionsColumnIndex: -1,
                      search: false,
                      paging: true,
                      sorting: false,
                      pageSize: 10,
                    }}
                    localization={{
                      body: {
                        emptyDataSourceMessage: (
                          <h6>
                            {_.get(
                              elements,
                              "joinAllUserElement.noRecordsFoundElement",
                              "No records to display"
                            )}
                          </h6>
                        ),
                      },
                      pagination: {
                        labelRowsSelect: _.get(
                          elements,
                          "customMaterialTableElement.labelRowsSelect",
                          "rows"
                        ),
                        previousTooltip: _.get(
                          elements,
                          "customMaterialTableElement.previousTooltip",
                          "previous"
                        ),
                        nextTooltip: _.get(
                          elements,
                          "customMaterialTableElement.nextTooltip",
                          "next"
                        ),
                      },
                    }}
                    detailPanel={(rowData) => {
                      return (
                        <div className="hideSearch my-3 px-3">
                          <Row>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "joinAllUserElement.fNameElement",
                                  "First Name"
                                )}
                                titleName={rowData.fName}
                              />
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "joinAllUserElement.lNameElement",
                                  "Last Name"
                                )}
                                titleName={rowData.lName}
                              />
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "joinAllUserElement.rideStatusElement",
                                  "Email"
                                )}
                                titleName={rowData.contactDetails.email}
                              />
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "joinAllUserElement.phoneElement",
                                  "Phone"
                                )}
                                titleName={
                                  rowData.contactDetails.mobile.primary.number
                                }
                              />
                            </Col>
                            <Col xl={3} lg={4} md={6} sm={6} className="mb-4">
                              <DesignCard
                                name={_.get(
                                  elements,
                                  "joinAllUserElement.moderationStatusElement",
                                  "DOB"
                                )}
                                titleName={helperFunctionForDate(rowData.dob)}
                              />
                            </Col>
                          </Row>
                          <div className="d-flex justify-content-center justify-content-lg-end position-relative ">
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "joinAllUserElement.joinButtonElement",
                                "JOIN"
                              )}
                              customClass={
                                "btn-outline-dark ml-2 bg-none btnthemeColor"
                              }
                              customClick={
                                this.props.singleRide
                                  ? this.props.singleRide.registrationFee !==
                                    "N/A"
                                    ? (e) =>
                                        this.handleApproveUserWithFee(
                                          e,
                                          rowData.guid
                                        )
                                    : (e) =>
                                        this.handleApproveUserWithoutFeeWithoutToggleModel(
                                          e,
                                          rowData.guid
                                        )
                                  : null
                              }
                            />
                          </div>
                        </div>
                      );
                    }}
                  />
                </div>
              )}
              <div className="d-flex justify-content-center justify-content-lg-end position-relative m-4">
                <CustomButton
                  customType={"button"}
                  name={_.get(
                    elements,
                    "joinAllUserElement.backButtonElement",
                    "Back"
                  )}
                  customClass={"btn-outline-dark bg-none btnthemeColor"}
                  customClick={() => this.handleGoBack()}
                />
              </div>
            </>
          </Col>
        </Row>
        <Modal className="modalcenter" isOpen={this.state.togglePaymentModal}>
          <ModalHeader toggle={this.handleToggleRejectModalWithoutId}>
            {_.get(
              elements,
              "joinAllUserElement.paymentMethodElement",
              "Payment Method"
            )}
          </ModalHeader>
          <ModalBody>
            <Label className="inputLabel">
              {_.get(
                elements,
                "joinAllUserElement.paymentLabel",
                "Select Method"
              )}
            </Label>
            <Input
              type="select"
              name="City"
              className="w-100 customeSelectBtn my-2"
              onChange={this.handleChangePaymentStatus}
            >
              <option value={"CASH"}>
                {_.get(
                  elements,
                  "joinWebUserListing.cashPaymentMethodElement",
                  "Cash"
                )}
              </option>
              <option value={"NET BANKING"}>
                {_.get(
                  elements,
                  "joinWebUserListing.netBankingPaymentMethodElement",
                  "Net Banking"
                )}
              </option>
              <option value={"CARD"}>
                {_.get(
                  elements,
                  "joinWebUserListing.cardPaymentMethodElement",
                  "Card"
                )}
              </option>
              <option value={"OTHERS"}>
                {_.get(
                  elements,
                  "joinWebUserListing.otherPaymentMethodElement",
                  "Others"
                )}
              </option>
            </Input>

            {this.state.paymentDetail === "OTHERS" ? (
              <React.Fragment>
                <Label className="inputLabel" for="--">
                  {_.get(
                    elements,
                    "joinAllUserElement.paymentMethodLabelElement",
                    "Enter Payment Method"
                  )}
                </Label>
                <FormGroup>
                  <Input
                    type="textarea"
                    placeholder={_.get(
                      elements,
                      "joinAllUserElement.paymentMethodPlaceHolderElement",
                      "Enter Payment Method"
                    )}
                    name="otherPaymentReason"
                    id="--"
                    value={this.state.otherPaymentReason}
                    className="my-2 inputText"
                    onChange={(e) => this.handleNameChange(e)}
                    required
                  />
                </FormGroup>
              </React.Fragment>
            ) : null}
          </ModalBody>
          <ModalFooter>
            <CustomButton
              customType={"submit"}
              name={_.get(
                elements,
                "joinAllUserElement.submitButtonElement",
                "Submit"
              )}
              customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
              customClick={(e) => this.handleApproveUserWithoutFee(e)}
            />
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
